/** Vertical padding preset for projection grid rows; independent of zoom. */
export type RowDensity = 'compact' | 'normal' | 'relaxed';

/**
 * Base row heights (px at 100% zoom). Stacked cells hold two lines of text
 * (plan at 13px, actual at ~10.7px) so they need ~26px minimum before padding.
 */
export const ROW_HEIGHTS: Record<RowDensity, { stacked: number; split: number; label: string }> = {
  compact: { stacked: 30, split: 22, label: 'Compact' },
  normal: { stacked: 36, split: 26, label: 'Normal' },
  relaxed: { stacked: 44, split: 30, label: 'Relaxed' },
};

export const DEFAULT_DENSITY: RowDensity = 'compact';
